import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import { Tooltip } from '../elements-tooltip/tooltip';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

const LineItem = ({ label, value, optionalValue, currencyType, customClass = '', attributes = {} }) => {
  const locale = ('undefined' !== typeof navigator) ? navigator.language : '';
  return (
    <SharedIntlProviderHOC>
      <tr className={`line-item ${customClass} ${optionalValue ? 'long-row' : 'short-row'}`} {...(attributes || {})}>
        <td className={`row-label ${label.optionalClass || ''} table-data`} {...(label.attributes || {})}>
          {label.content}
          {label.optionalTooltip &&
              <span className="tooltip-style-left">
                <Tooltip tooltip={label.optionalTooltip} />
              </span>
          }
        </td>
        {
          value &&
          <td className={`${optionalValue ? 'middle-data' : 'right-data'} table-data ${value.optionalClass || ''}`} {...(value.attributes || {})}>
            {value.optionalTooltip &&
              <span className="tooltip-style-right">
                <Tooltip tooltip={value.optionalTooltip} />
              </span>
            }
            {
              value.customValue
                ? value.customValue
                : value.amount && <FormattedNumber value={value.amount} currency={currencyType} style={'currency'} />
            }
          </td>
        }
        {
          optionalValue &&
          <td className={`${optionalValue.optionalClass || ''} table-data right-data`} {...(optionalValue.attributes || {})}>
            {optionalValue.optionalTooltip &&
              <span className="tooltip-style-right">
                <Tooltip tooltip={optionalValue.optionalTooltip} />
              </span>}
            {
              optionalValue.customValue
                ? optionalValue.customValue
                : optionalValue.amount && <FormattedNumber value={optionalValue.amount} currency={currencyType} style={'currency'} />
            }
          </td>
        }
      </tr>
    </SharedIntlProviderHOC>
  );
};

export { LineItem };

LineItem.propTypes = {
  label: PropTypes.shape({
    content: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    optionalTooltip: PropTypes.object,
    attributes: PropTypes.object
  }).isRequired,
  value: PropTypes.shape({
    amount: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    optionalClass: PropTypes.string,
    optionalTooltip: PropTypes.object,
    attributes: PropTypes.object
  }),
  optionalValue: PropTypes.shape({
    amount: PropTypes.number,
    optionalClass: PropTypes.string,
    optionalTooltip: PropTypes.object,
    attributes: PropTypes.object
  }),
  currencyType: PropTypes.string.isRequired,
  customClass: PropTypes.string,
  attributes: PropTypes.object
};
